module.exports = "https://99designs-start-assets.imgix.net/js/c267752470282c6d99a2c52de02f7f1f.svg";